import api from "../../Hooks/axiosApi";

export const getStaffsService = () => {
    const response = api.get('/api/Crm/GetStaff');
    return response;
};

export const manageUserService = (data: any) => {
    const formData = new FormData();
    Object.keys(data).forEach((key) => {
        formData.append(key, data[key]);
    });
    const response = api.post('/api/Crm/ManageStaff', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
    return response;
};

export const getStaffRolesService = () => {
    const response = api.get('/api/Crm/GetStaffRoles');
    return response;
};
export const getStaffByIdService = (id : any) => {
    const response = api.get(`/api/Crm/GetStaff`,{
        params: {
            userId : id
        }
    });
    return response;
};